import "./Loader.css"
const Loader = ({width="16px",className=""}) => <div className={`lds-container`}>
        <div className={`lds-facebook ${className}`} style={{width: `calc((${width} * 3) + ((${width} / 2) * 4))`}}>
            <div style={{width, left:`calc(${width} / 2)`}}></div>
            <div style={{width, left:`calc((${width} / 2) * 4)`}}></div>
            <div style={{width, left:`calc((${width} / 2)  * 7)`}}></div>
        </div>
    </div>
export default Loader